import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";

function TodoDialogEditPriority({ isOpen, onClose, eventTodo, setEventTodo }) {

    const [priority, setPriority] = useState(eventTodo.category);

    const priorities = ["Urgent", "High", "Medium", "Low"];
    const getPriorityIconColor = (priority) => {
        switch (priority) {
            case "Low":
                return "rgb(56, 142, 60)"; // Replace with your desired color
            case "Medium":
                return "rgb(255, 191, 0)"; // Replace with your desired color #b8ab10
            case "High":
                return "rgb(245, 124, 0)"; // Replace with your desired color
            case "Urgent":
                return "rgb(211, 47, 47)"; // Replace with your desired color
            default:
                return "#151269"; // Default color if priority is not recognized
        }
    };

    function handlePriorityChange(event){
        setPriority(event.target.value);
    }
    function saveTodoItemPriority() {
        // Corrected syntax: added parentheses around the object
        setEventTodo((prev) => ({
            ...prev,
            priority: priority
        }));
        onClose(); // Don't forget to close the dialog after saving!
    }


    return (

        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                To-Do Item Priority
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent sx={{ pt: 2 }}>

                <FormControl fullWidth margin="dense">
                    <InputLabel>Priority</InputLabel>
                    <Select
                        size="small"
                        label="Priority"
                        value={priority}
                        onChange={handlePriorityChange}
                    >
                        {priorities.map((prio) => (
                            <MenuItem key={prio} value={prio}>
                                <Box display="flex" alignItems="center" width="100%">
                                    {prio}
                                    <Box
                                        sx={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            backgroundColor: getPriorityIconColor(prio),
                                            marginLeft: "auto", // Pushes to the right side
                                        }}
                                    />
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                    <Button variant="contained" onClick={saveTodoItemPriority}>Save</Button>
                </Box>
            </DialogContent>

        </Dialog>
    )
}

export default TodoDialogEditPriority;